import React, { useEffect, useState } from 'react'
import { useLocation, useNavigate } from 'react-router-dom';
import CryptoJS from "crypto-js";
import axios from 'axios';
import { Alert, Button, TextField, Typography } from '@mui/material';
import Header from '../components/Header';
import { Capacitor } from "@capacitor/core";
import { App  } from '@capacitor/app'; // Renombra la importación

const ResetPassword = () => {
    const location = useLocation();
    const [tokenValid, setTokenValid] = useState(null);
    const [token, setToken] = useState("");
    let [msgError, setMsgError] = useState("")

    let [enableConfirm, setEnableConfirm] = useState(false);

    const [openModal, setOpenModal] = React.useState(false);

    let [nameState, setNameState] = useState(false);
    let [passwordState, setPasswordState] = useState(false);

    const [email, setEmail] = useState('');
    const [password2, setPassword2] = useState('');
    const [password, setPassword] = useState('');

    const [showAlert, setShowAlert] = useState(false);
    const [alertDetails, setAlertDetails] = useState('');

    const navigate = useNavigate();

    const nameValidation = (event) => {
        setEmail(event.target.value)
    }

    const passwordValidation = (event) => {
        setPassword(event.target.value)
    }

    const passwordValidation2 = (event) => {
        setPassword2(event.target.value)
    }

    function decryptData(encryptedText) {
        // Define la misma clave que usaste en el backend
        const key = "AKeyThatIsAtLeast32CharactersLongForHS256";

        // Decodifica el texto encriptado de base64
        const encryptedBytes = CryptoJS.enc.Base64.parse(encryptedText);

        // Extrae el IV (los primeros 16 bytes) y el contenido encriptado
        const iv = CryptoJS.lib.WordArray.create(encryptedBytes.words.slice(0, 4), 16);
        const encryptedContent = CryptoJS.lib.WordArray.create(encryptedBytes.words.slice(4));

        // Deriva la clave usando SHA256
        const hashedKey = CryptoJS.SHA256(key);

        // Desencripta el contenido
        const decrypted = CryptoJS.AES.decrypt(
            { ciphertext: encryptedContent },
            hashedKey,
            {
                iv: iv,
                mode: CryptoJS.mode.CBC,
                padding: CryptoJS.pad.Pkcs7
            }
        );

        // Convierte el resultado a texto legible
        return decrypted.toString(CryptoJS.enc.Utf8);
    }

    function recoverPassword() {
        const packageFromURL = getPackageFromURL();
        // console.log("packageFromURL")
        // console.log(packageFromURL)
        const token = localStorage.getItem('jwt_token');
        let password_local;
        if (password === '' || password2 === '') {
            setShowAlert(true);
            setAlertDetails('Por favor, completa todos los campos para poder iniciar sesión.')
            return;
            // } else if(email.trim() !== props.user.email) {
            //   setShowAlert(true);
            //   setAlertDetails('El mail ingresado es incorrecto.')
            // } else if(password.trim() !== props.user.pass) {
            //   setShowAlert(true);
            //   setAlertDetails('La contraseña ingresada es incorrecta.')
        } else {
            if (password === password2) {

                const headers = 'content-type: application/json; charset=utf-8'

                // const encryptionKey = "YfshOureTriyngt0h4$MiYwAR3aJErkP1e%s3D0n7";
                const encryptionKey = "EsteEsUnEjemploDeClaveDe32Caracteres!";


                let data = {
                    password: password,
                    email: email,
                    id: packageFromURL,
                }

                const jsonData = JSON.stringify(data);
                const encripted_data = CryptoJS.AES.encrypt(jsonData, encryptionKey).toString();


                axios.put(`https://socializeapi.azurewebsites.net/api/UpdateUser`, { data: encripted_data }, {
                    headers
                })
                    .then(response => {
                        if (response.data !== null) {
                            if (Capacitor.isNativePlatform()) {
                                // Dispositivo móvil: usar deep link para abrir dentro de la app
                                // window.location.href = "hisocialize://#/login"; // Esquema personalizado
                                App.openUrl({ url: "hisocialize://hisocialize.netlify.app/#/login" });
                            } else {
                                // Escritorio: navegación normal
                                navigate("/login");
                            }
                        } else {
                            setShowAlert(true);
                            setAlertDetails('La cuenta a la que intenta ingresar no existe.')
                        }

                    })
                    .catch(error => {
                        console.log(`Error obteniendo datos: ${error}`);
                    });
            } else {
                setShowAlert(true);
                setMsgError("Debes ingresar la misma contraseña en ambos campos.")
            }

        }

        setShowAlert(false);
        // Aquí puedes agregar la lógica para validar y enviar los datos del formulario
    }

    function forgottenPass() {
        try {
            const headers = { 'Content-Type': 'application/json; charset=utf-8' };
            const token = localStorage.getItem('jwt_token');
            const encryptionKey = "EsteEsUnEjemploDeClaveDe32Caracteres!";
            let datos = {
                password: password,
                email: email
            }

            const password_local = CryptoJS.AES.encrypt(password, encryptionKey).toString();

            axios.post(`https://socializeapi.azurewebsites.net/api/RecoverPassword`, { Email: email }, { headers })
                .then(response => {
                    if (response.data !== null) {
                        // store.dispatch(LOGIN_USER_action([props.user.name, email, props.user.phone, password]))
                    } else {
                        setShowAlert(true);
                        setAlertDetails('La cuenta a la que intenta ingresar no existe.')
                    }

                })
                .catch(error => {
                    console.log(`Error obteniendo datos: ${error}`);
                });
        } catch (error) {

        }
    }


    function AAA() {
        const validateToken = async () => {
            const tokenFromURL = getTokenFromURL();
            if (!tokenFromURL) {
                // navigate("/error"); // Redirigir si no hay token en la URL
                return;
            }
            setToken(tokenFromURL);

            // console.log("tokenFromURL")
            // console.log(tokenFromURL)

            try {
                const response = await fetch("https://socializeapi.azurewebsites.net/api/validate-reset-token", {
                    method: "POST",
                    headers: { "Content-Type": "application/json" },
                    body: JSON.stringify({ Token: tokenFromURL }),
                });

                const data = await response.json();

                if (response.ok && data.isValid) {
                    setTokenValid(true); // Token válido, el usuario puede restablecer la contraseña
                } else {
                    setTokenValid(false);
                    // navigate("/error"); // Redirigir si el token no es válido
                }
            } catch (error) {
                console.error("Error al validar el token:", error);
                setTokenValid(false);
                // navigate("/error"); // Redirigir en caso de error
            }
        };

        validateToken();
    }

    const getTokenFromURL = () => {
        const queryParams = new URLSearchParams(location.search);
        return queryParams.get("token");
    };

    const getEmailFromURL = () => {
        const queryParams = new URLSearchParams(location.search);
        return queryParams.get("email");
    };

    const getPackageFromURL = () => {
        const queryParams = new URLSearchParams(location.search);
        return queryParams.get("package");
    };

    useEffect(() => {
        // Manejar apertura desde el enlace
        App.addListener('appUrlOpen', ({ url }) => {
            const route = new URL(url).pathname; // Extrae la ruta (ej: "/reset-password")
            navigate(route); // Navega a la ruta correspondiente
        });

        // Verificar URL al iniciar la aplicación
        App.getLaunchUrl().then(({ url }) => {
            if (url) {
                const route = new URL(url).pathname; // Extrae la ruta (ej: "/reset-password")
                navigate(route); // Navega a la ruta correspondiente
            }
        });
    }, [navigate]);

    useEffect(() => {
        const validateToken = async () => {
            const tokenFromURL = getTokenFromURL();
            const emailFromURL = getEmailFromURL();

            if (!tokenFromURL) {
                // navigate("/error"); // Redirigir si no hay token en la URL
                navigate("/login"); // Redirigir si no hay token en la URL
                return;
            }
            setToken(tokenFromURL);


            


            try {
                const response = await fetch("https://socializeapi.azurewebsites.net/api/validate-reset-token", {
                    method: "POST",
                    headers: { "Content-Type": "application/json" },
                    body: JSON.stringify({ Token: tokenFromURL }),
                });


                const data = await response.json();
                console.log("data")
                console.log(data)

                if (response.ok && data.isValid) {
                    setTokenValid(true); // Token válido, el usuario puede restablecer la contraseña

                    setEmail(emailFromURL)
                    // console.log("token valido")
                } else {
                    setTokenValid(false);
                    // navigate("/error"); // Redirigir si el token no es válido
                    navigate("/login"); // Redirigir si el token no es válido
                }
            } catch (error) {
                console.error("Error al validar el token:", error);
                setTokenValid(false);
                // navigate("/error"); // Redirigir en caso de error
                navigate("/login"); // Redirigir en caso de error
            }
        };

        validateToken();

    }, [location, navigate]);

    return (
        <>
            {/* <Header></Header> */}
            <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh' }}>

                {/* Formulario */}
                <div style={{
                    flexGrow: 3,
                    display: 'flex',
                    flexDirection: 'column',
                    justifyContent: 'center',
                    alignItems: 'center',
                    maxWidth: '50%',
                    minWidth: 400,
                }}>
                    <p style={{
                        // color: '#009688',
                        color: (showAlert ? '#DC3545' : '#0D6EFD'),
                        fontWeight: '500',
                        fontSize: `clamp(32px, 4vw, 48px)`,
                        marginBottom: 64
                    }}>HiSocialize</p>

                    <p style={{
                        // color: '#009688',
                        color: (showAlert ? '#DC3545' : '#0D6EFD'),
                        fontWeight: '500',
                        fontSize: `clamp(32px, 2vw, 40px)`,
                        marginBottom: 64,
                        textAlign: 'center'
                    }}>Reestablezca su contraseña!</p>

                    {/* Formulario */}
                    <div style={{ width: '80%', display: 'flex', flexDirection: 'column' }}>
                        <TextField
                            style={{
                                marginTop: 16
                            }}
                            label="Ingrese la nueva contraseña"
                            variant="outlined"
                            type="password"
                            value={password}
                            onChange={passwordValidation}
                            required
                        />
                        <TextField
                            style={{
                                marginTop: 16
                            }}
                            label="Repita la nueva contraseña"
                            variant="outlined"
                            type="password"
                            value={password2}
                            onChange={passwordValidation2}
                            required
                        />
                        {msgError && (
                            <Typography fontSize={12} marginBottom={2} color={'red'}>{msgError}</Typography>
                        )}

                        <Button variant="contained" color={showAlert ? 'error' : 'primary'} onClick={recoverPassword} style={{ display: (tokenValid ? null : 'none'), marginTop: 16 }}>
                            Reestablecer contraseña
                        </Button>
                        {/* <Button variant="contained" color={showAlert ? 'error' : 'primary'} onClick={AAA}>
                            Reestablecer contraseña
                        </Button> */}

                        {showAlert && (
                            <Alert severity="warning">
                                {alertDetails}
                            </Alert>
                        )}
                    </div>
                </div>
            </div>
        </>
    )
}

export default ResetPassword
